module.exports = __webpack_public_path__ + "img/8.dbda32f5.png";